import { render, staticRenderFns } from "./leave-content-item.vue?vue&type=template&id=b7bcf2c6&scoped=true"
import script from "./leave-content-item.vue?vue&type=script&lang=js"
export * from "./leave-content-item.vue?vue&type=script&lang=js"
import style0 from "./leave-content-item.vue?vue&type=style&index=0&id=b7bcf2c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bcf2c6",
  null
  
)

export default component.exports